function mobile_logout() {
    console.log('Mobile logout');
    window.flutter_inappwebview.callHandler('Android', 'Internal error')
        .then(function (result) {
            console.log('logout');
            //alert(result);
        });
    window.location.href = "/login";
}